<template>
  <div class="index-container">
    <commentFilter ref="commentFilter" :status="star">
      <el-button type="primary" size="small" @click="handleQuery()"
        >查询</el-button
      >
      <el-button type="warning" size="small" @click="handlesync()"
        >获取</el-button
      >
    </commentFilter>
    <div class="tabs-container">
      <el-tabs v-model="star" type="border-card" @tab-click="activeChange">
        <el-tab-pane name="0">
          <span slot="label"><i class="el-icon-star-off"></i> 全部</span>
        </el-tab-pane>
        <el-tab-pane name="10">
          <span slot="label"><i class="el-icon-star-on"></i>1星</span>
        </el-tab-pane>
        <el-tab-pane name="20">
          <span slot="label"><i class="el-icon-star-on"></i>2星</span>
        </el-tab-pane>
        <el-tab-pane name="30">
          <span slot="label"><i class="el-icon-star-on"></i>3星</span>
        </el-tab-pane>
        <el-tab-pane name="40">
          <span slot="label"><i class="el-icon-star-on"></i>4星</span>
        </el-tab-pane>
        <el-tab-pane name="50">
          <span slot="label"><i class="el-icon-star-on"></i>5星</span>
        </el-tab-pane>
      </el-tabs>
      <div class="tab-content">
        <commentList ref="commentList" :filter="filter" />
      </div>
    </div>
    <syncComment ref="syncComment" />
  </div>
</template>
  <script>
import commentList from "./components/commentList.vue";
import commentFilter from "./components/commentFilter.vue";
import syncComment from "./components/syncComment.vue";
export default {
  components: { commentFilter, commentList, syncComment },
  data() {
    return {
      filter: {
        star: "0",
      },
      star: "0",
    };
  },
  methods: {
    activeChange() {
      this.handleQuery();
    },
    handlesync() {
      this.$refs.syncComment.show();
    },
    handleQuery() {
      let tempfilter = this.$refs.commentFilter.getfilter();
      tempfilter.star = this.star;
      this.filter = tempfilter;
    },
  },
  mounted() {
    this.handleQuery();
  },
};
</script>
  <style lang="scss" scoped>
.index-container {
  .pagination {
    margin-top: 10px;
    text-align: right;
  }
  padding: 10px;
  .input {
    width: 150px;
  }
  .tabs-container {
    /deep/.el-tabs--border-card > .el-tabs__content {
      padding: 0;
      height: 1px;
    }
    .tab-content {
      margin-top: -2px;
      border: 1px solid #dcdfe6;
      border-top: 0;
      padding: 15px;
      background: #fff;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    }
  }
}
</style>